import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useServerVersion, isServerNewer } from "../utils/serverVersion";

// Shown when the API reports a newer major.minor than the bundle this tab is
// running — the tab was opened before a deploy. Never reloads by itself, so an
// unsaved edit form is not lost.
export default function UpdateBanner() {
  const { t } = useTranslation();
  const serverVersion = useServerVersion();
  const [dismissedFor, setDismissedFor] = useState(null);

  if (!isServerNewer(serverVersion) || dismissedFor === serverVersion) return null;

  return (
    <div id="update-banner" className="update-banner" role="status">
      <span>
        <i className="bi bi-arrow-repeat me-2"></i>
        {t("update_available")}
      </span>
      <button className="btn btn-sm ez-button-full ms-3" onClick={() => window.location.reload()}>
        {t("update_reload")}
      </button>
      <button
        className="btn btn-sm btn-link ms-1"
        onClick={() => setDismissedFor(serverVersion)}
        title={t("update_later")}
        aria-label={t("update_later")}
      >
        <i className="bi bi-x-lg"></i>
      </button>
    </div>
  );
}
